import React from "react";
import logo from "../assets/img/logo1.png";

const AwakiloLoader = ({
  fullScreen = false,
  overlay = false,
  className = "",
}) => {
  const loader = (
    <div className="relative flex h-36 w-36 items-center justify-center">
      <span className="absolute h-36 w-36 rounded-full border border-[#0E9E0B]/15 bg-[#0E9E0B]/5 animate-ping" />
      <span
        className="absolute h-28 w-28 rounded-full border border-[#0E9E0B]/20 bg-white/35 animate-ping"
        style={{ animationDelay: "450ms" }}
      />
      <div className="awakilo-loader-core relative z-10 flex h-24 w-24 items-center justify-center rounded-full bg-white p-4 shadow-[0_18px_40px_rgba(15,23,42,0.16)] ring-1 ring-[#0E9E0B]/10">
        <img
          className="awakilo-loader-float h-full w-full object-contain"
          src={logo}
          alt="Awakilo logo"
        />
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div
        className={`fixed inset-0 z-[120] flex items-center justify-center bg-[#F4F7F5]/88 backdrop-blur-sm ${className}`}
      >
        {loader}
      </div>
    );
  }

  if (overlay) {
    return (
      <div
        className={`absolute inset-0 z-40 flex items-center justify-center bg-[#F4F7F5]/78 backdrop-blur-sm ${className}`}
      >
        {loader}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>{loader}</div>
  );
};

export default AwakiloLoader;
